import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

// Status Türkçe çeviri
const getStatusText = (status) => {
    switch (status) {
        case 'processing':
            return 'Hazırlanıyor';
        case 'completed':
            return 'Tamamlandı';
        case 'pending':
            return 'Beklemede';
        case 'on-hold':
            return 'Bekletildi';
        case 'cancelled':
            return 'İptal Edildi';
        default:
            return status;
    }
};

// Türkiye şehir kodları çevirisi
const getCityName = (stateCode) => {
    const cityMap = {
        TR01: 'Adana',
        TR02: 'Adıyaman',
        TR03: 'Afyonkarahisar',
        TR04: 'Ağrı',
        TR05: 'Amasya',
        TR06: 'Ankara',
        TR07: 'Antalya',
        TR08: 'Artvin',
        TR09: 'Aydın',
        TR10: 'Balıkesir',
        TR11: 'Bilecik',
        TR12: 'Bingöl',
        TR13: 'Bitlis',
        TR14: 'Bolu',
        TR15: 'Burdur',
        TR16: 'Bursa',
        TR17: 'Çanakkale',
        TR18: 'Çankırı',
        TR19: 'Çorum',
        TR20: 'Denizli',
        TR21: 'Diyarbakır',
        TR22: 'Edirne',
        TR23: 'Elazığ',
        TR24: 'Erzincan',
        TR25: 'Erzurum',
        TR26: 'Eskişehir',
        TR27: 'Gaziantep',
        TR28: 'Giresun',
        TR29: 'Gümüşhane',
        TR30: 'Hakkari',
        TR31: 'Hatay',
        TR32: 'Isparta',
        TR33: 'Mersin',
        TR34: 'İstanbul',
        TR35: 'İzmir',
        TR36: 'Kars',
        TR37: 'Kastamonu',
        TR38: 'Kayseri',
        TR39: 'Kırklareli',
        TR40: 'Kırşehir',
        TR41: 'Kocaeli',
        TR42: 'Konya',
        TR43: 'Kütahya',
        TR44: 'Malatya',
        TR45: 'Manisa',
        TR46: 'Kahramanmaraş',
        TR47: 'Mardin',
        TR48: 'Muğla',
        TR49: 'Muş',
        TR50: 'Nevşehir',
        TR51: 'Niğde',
        TR52: 'Ordu',
        TR53: 'Rize',
        TR54: 'Sakarya',
        TR55: 'Samsun',
        TR56: 'Siirt',
        TR57: 'Sinop',
        TR58: 'Sivas',
        TR59: 'Tekirdağ',
        TR60: 'Tokat',
        TR61: 'Trabzon',
        TR62: 'Tunceli',
        TR63: 'Şanlıurfa',
        TR64: 'Uşak',
        TR65: 'Van',
        TR66: 'Yozgat',
        TR67: 'Zonguldak',
        TR68: 'Aksaray',
        TR69: 'Bayburt',
        TR70: 'Karaman',
        TR71: 'Kırıkkale',
        TR72: 'Batman',
        TR73: 'Şırnak',
        TR74: 'Bartın',
        TR75: 'Ardahan',
        TR76: 'Iğdır',
        TR77: 'Yalova',
        TR78: 'Karabük',
        TR79: 'Kilis',
        TR80: 'Osmaniye',
        TR81: 'Düzce',
    };
    return cityMap[stateCode] || stateCode;
};

// Ülke kodları çevirisi
const getCountryName = (countryCode) => {
    const countryMap = {
        TR: 'Türkiye',
        US: 'Amerika Birleşik Devletleri',
        DE: 'Almanya',
        FR: 'Fransa',
        GB: 'Birleşik Krallık',
        IT: 'İtalya',
        ES: 'İspanya',
        NL: 'Hollanda',
        BE: 'Belçika',
        AT: 'Avusturya',
        CH: 'İsviçre',
        GR: 'Yunanistan',
        BG: 'Bulgaristan',
    };
    return countryMap[countryCode] || countryCode;
};

// Ortak kargo etiketi yazdırma şablonu
export const printShippingLabel = (order) => {
    const printWindow = window.open('', '_blank');
    const shippingInfo = order.shipping || order.billing;
    const items = order.line_items || [];

    const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <title>Kargo Etiketi - Sipariş #${order.number}</title>
            <style>
                body { 
                    font-family: Arial, sans-serif; 
                    margin: 20px; 
                    font-size: 12px; 
                    color: #000;
                    background: #fff;
                }
                .header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 30px;
                    padding-bottom: 20px;
                    border-bottom: 3px solid #000;
                }
                .company-info {
                    flex: 1;
                }
                .company-name {
                    font-size: 20px;
                    font-weight: bold;
                    color: #000;
                    margin-bottom: 5px;
                }
                .company-subtitle {
                    font-size: 12px;
                    color: #333;
                    margin-bottom: 10px;
                }
                .logo {
                    width: 100px;
                    height: 100px;
                    margin-left: 20px;
                }
                .order-header {
                    background: #000;
                    color: #fff;
                    padding: 20px;
                    border-radius: 0;
                    margin-bottom: 30px;
                    text-align: center;
                    border: 2px solid #000;
                }
                .order-header h1 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: bold;
                    color: #fff;
                }
                .order-info { 
                    margin-bottom: 30px;
                    padding: 15px;
                    border: 2px solid #000;
                    background: #f8f8f8;
                }
                .address { 
                    border: 2px solid #000; 
                    padding: 15px; 
                    margin: 10px 0; 
                    border-radius: 0;
                    background: #fff;
                }
                .items { 
                    border: 2px solid #000; 
                    border-radius: 0; 
                    overflow: hidden;
                    margin-top: 20px;
                    background: #fff;
                }
                .items table { 
                    width: 100%; 
                    border-collapse: collapse; 
                }
                .items th, .items td { 
                    padding: 12px; 
                    text-align: left; 
                    border-bottom: 1px solid #000; 
                    vertical-align: top;
                }
                .items th { 
                    background: #000;
                    color: #fff;
                    font-weight: bold;
                    border-bottom: 2px solid #000;
                }
                .items tr:nth-child(even) {
                    background: #f8f8f8;
                }
                .product-details {
                    font-size: 11px;
                    color: #333;
                    margin-top: 5px;
                    line-height: 1.4;
                    font-style: italic;
                }
                h2 { 
                    color: #000; 
                    margin-bottom: 10px;
                    font-weight: bold;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                }
                h3 { 
                    color: #000; 
                    margin-bottom: 8px;
                    font-weight: bold;
                    text-transform: uppercase;
                }
                .customer-note {
                    margin-top: 20px; 
                    padding: 15px; 
                    background: #f0f0f0; 
                    border: 2px solid #000;
                    border-radius: 0;
                    font-weight: bold;
                }
                .print-date {
                    text-align: right;
                    color: #333;
                    font-size: 10px;
                    margin-top: 20px;
                    border-top: 1px solid #000;
                    padding-top: 10px;
                }
                .footer {
                    text-align: center;
                    margin-top: 30px;
                    padding-top: 15px;
                    border-top: 2px solid #000;
                    color: #000;
                    font-weight: bold;
                }
                .status-info {
                    font-weight: bold;
                    color: #000;
                }
                .contact-info {
                    margin-top: 10px;
                    padding: 10px;
                    border: 1px solid #000;
                    background: #f8f8f8;
                }
                @media print {
                    body { 
                        margin: 0; 
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    @page { 
                        margin: 15mm; 
                        size: A4;
                    }
                    .order-header {
                        background: #000 !important;
                        color: #fff !important;
                    }
                    .items th {
                        background: #000 !important;
                        color: #fff !important;
                    }
                }
            </style>
        </head>
        <body>
            <div class="header">
                <div class="company-info">
                    <div class="company-name">AHŞAPLAR.COM</div>
                    <div class="company-subtitle">Kaliteli Ahşap Ürünleri ve Mobilya Çözümleri</div>
                </div>
                <img src="src/assets/images/ahsaplar.png" alt="Ahşaplar.com Logo" class="logo" onerror="this.style.display='none'">
            </div>

            <div class="order-header">
                <h1>KARGO ETİKETİ #${order.number}</h1>
                <p style="margin: 10px 0 0 0; font-size: 14px; color: #fff;">Tarih: ${format(
                    new Date(order.date_created),
                    'dd MMMM yyyy HH:mm',
                    { locale: tr }
                )}</p>
            </div>
            
            <div class="order-info">
                <div class="status-info">
                    <strong>Sipariş Durumu:</strong> ${getStatusText(order.status)}<br>
                    <strong>Ödeme Yöntemi:</strong> ${order.payment_method_title || 'Belirtilmemiş'}
                </div>
            </div>

            <div class="address">
                <h3>📍 TESLİMAT ADRESİ</h3>
                <p><strong>${shippingInfo?.first_name || ''} ${shippingInfo?.last_name || ''}</strong></p>
                ${
                    shippingInfo?.company &&
                    shippingInfo.company !== `${shippingInfo?.first_name || ''} ${shippingInfo?.last_name || ''}`.trim()
                        ? `<p><strong>Firma:</strong> ${shippingInfo.company}</p>`
                        : ''
                }
                <p>${shippingInfo?.address_1 || ''}</p>
                ${shippingInfo?.address_2 ? `<p>${shippingInfo.address_2}</p>` : ''}
                <p><strong>${shippingInfo?.city || ''} ${shippingInfo?.postcode || ''}</strong></p>
                <p>${shippingInfo?.state ? getCityName(shippingInfo.state) : ''}, ${
        shippingInfo?.country ? getCountryName(shippingInfo.country) : ''
    }</p>
                
                <div class="contact-info">
                    ${shippingInfo?.phone ? `<p><strong>📞 Telefon:</strong> ${shippingInfo.phone}</p>` : ''}
                    ${order.billing?.email ? `<p><strong>✉ E-posta:</strong> ${order.billing.email}</p>` : ''}
                </div>
            </div>

            ${
                order.customer_note
                    ? `
                <div class="customer-note">
                    <strong>📝 MÜŞTERİ NOTU:</strong><br>
                    ${order.customer_note}
                </div>
            `
                    : ''
            }

            <div class="items">
                <table>
                    <thead>
                        <tr>
                            <th style="width: 70%;">ÜRÜN ADI VE DETAYLARI</th>
                            <th style="text-align: center; width: 30%;">ADET</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${items
                            .map((item) => {
                                // Ürün varyasyonları ve meta verilerini al
                                const variations = item.meta_data || [];
                                const variationText = variations
                                    .filter((meta) => meta.display_key && meta.display_value)
                                    .map((meta) => `${meta.display_key}: ${meta.display_value}`)
                                    .join(', ');

                                return `
                            <tr>
                                <td>
                                    <strong>${item.name || 'Ürün Adı'}</strong>
                                    ${variationText ? `<div class="product-details">${variationText}</div>` : ''}
                                    ${item.sku ? `<div class="product-details">SKU: ${item.sku}</div>` : ''}
                                </td>
                                <td style="text-align: center; font-weight: bold; font-size: 16px;">
                                    ${item.quantity || 0} adet
                                </td>
                            </tr>
                        `;
                            })
                            .join('')}
                    </tbody>
                </table>
            </div>

            <div class="footer">
                <p><strong>AHŞAPLAR.COM</strong> - Kaliteli Ahşap Ürünler</p>
                <p>www.ahsaplar.com</p>
            </div>

            <div class="print-date">
                Yazdırılma Tarihi: ${format(new Date(), 'dd MMMM yyyy HH:mm', { locale: tr })}
            </div>
        </body>
        </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
        printWindow.print();
    }, 250);
};
